import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountryProps, LanguageProps } from "./types";

interface DashboardState {
  countries: CountryProps[];
  languages: LanguageProps[];
}

const initialState: DashboardState = {
  countries: [],
  languages: [],
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    saveCountries: (state, action: PayloadAction<CountryProps[]>) => {
      return {
        ...state,
        countries: action.payload,
      };
    },
    saveLanguages: (state, action: PayloadAction<LanguageProps[]>) => {
      return {
        ...state,
        languages: action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { saveCountries, saveLanguages } = dashboardSlice.actions;

export default dashboardSlice.reducer;
